@if (device()) {
    <form
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit($event)"
    >
        <dl class="grid-container vertical-gutter-lg">
            <app-portal-widget-details
                class="g-12"
                heading="Gerätetyp"
                [detail]="device().ObjectType"
            >
            </app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 sm:g-6"
                [heading]="device().ObjectType === 'Haushaltsgerät' ? 'Gerätetyp 2' : 'Hersteller'"
                [detail]="device().ObjectDescription"
            >
            </app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 sm:g-6"
                [heading]="device().ObjectType === 'Haushaltsgerät' ? 'Marke' : 'Modell und Speicherkapazität'"
                [detail]="device().ObjectModel"
            >
            </app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 sm:g-6"
                heading="Kaufpreis"
                [detail]="device().ObjectValue"
            >
            </app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 sm:g-6"
                heading="Kaufdatum"
                [detail]="device().ObjectDate"
            >
            </app-portal-widget-details>
            @if (deviceComplete()) {
                <app-portal-widget-details
                    class="g-12"
                    [heading]="isSmartphone() ? 'IMEI' : 'Seriennummer'"
                    [detail]="device().ObjectDetail"
                    [tooltipText]="isSmartphone() ? imeiTooltip : undefined"
                >
                </app-portal-widget-details>
            } @else {
                <div class="g-12 form-control">
                    <label
                        >{{ objectTypeLabel() + '*' }}:
                        @if (isSmartphone()) {
                            <app-info-tooltip [text]="imeiTooltip"></app-info-tooltip>
                        }
                        <input
                            formControlName="objectDetail"
                            [placeholder]="objectTypeLabel() + '*'"
                            autofocus
                            required
                            [attr.aria-errormessage]="id + '-object-detail'"
                            [attr.aria-invalid]="showError('objectDetail')"
                        />
                    </label>
                    @if (showError('objectDetail', 'required')) {
                        <span
                            [id]="id + '-object-detail'"
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib die {{ isSmartphone() ? 'IMEI' : 'Seriennummer' }} des Gerätes an.</span
                        >
                    } @else if (showError('objectDetail', 'minlength')) {
                        <span
                            [id]="id + '-object-detail'"
                            class="form-error-note"
                            aria-live="polite"
                        >
                            Die Seriennummer sollte mindestens drei Zeichen lang sein.
                        </span>
                    } @else if (showError('objectDetail', 'notAnIMEI')) {
                        <span
                            [id]="id + '-object-detail'"
                            class="form-error-note"
                            aria-live="polite"
                        >
                            Die IMEI ist 15 Zeichen lang und besteht nur aus Zahlen.
                        </span>
                    } @else if (showError('objectDetail', 'invalidIMEI')) {
                        <span
                            [id]="id + '-object-detail'"
                            class="form-error-note"
                            aria-live="polite"
                        >
                            Bitte gib eine valide IMEI an.
                        </span>
                    }
                </div>
            }
        </dl>
        @if (!deviceComplete()) {
            <div class="grid-container m-32:t">
                <button
                    class="g-12 sm:g-6 sm:g-offset-6 -blue"
                    type="submit"
                    value="device"
                    [disabled]="formGroup.controls.objectDetail.invalid"
                >
                    <i ctrlIcon="save"></i>Speichern
                </button>
            </div>
        }
        @if (lens()) {
            <dl class="grid-container vertical-gutter-lg m-16:t">
                <hr class="g-12" />
                <app-portal-widget-details
                    class="g-12"
                    heading="Gerätetyp"
                    [detail]="lens().ObjectType"
                >
                </app-portal-widget-details>
                <app-portal-widget-details
                    class="g-12 sm:g-6"
                    heading="Hersteller"
                    [detail]="lens().ObjectDescription"
                >
                </app-portal-widget-details>
                <app-portal-widget-details
                    class="g-12 sm:g-6"
                    heading="Modell"
                    [detail]="lens().ObjectModel"
                >
                </app-portal-widget-details>
                <app-portal-widget-details
                    class="g-12 sm:g-6"
                    heading="Kaufpreis"
                    [detail]="lens().ObjectValue"
                >
                </app-portal-widget-details>
                <app-portal-widget-details
                    class="g-12 sm:g-6"
                    heading="Kaufdatum"
                    [detail]="lens().ObjectDate"
                >
                </app-portal-widget-details>
                @if (lensComplete()) {
                    <app-portal-widget-details
                        class="g-12"
                        heading="Seriennummer"
                        [detail]="lens().ObjectDetail"
                    >
                    </app-portal-widget-details>
                } @else {
                    <div class="g-12 form-control">
                        <label
                            >Seriennummer*:
                            <input
                                formControlName="lensObjectDetail"
                                placeholder="Seriennummer*"
                                autofocus
                                required
                                [attr.aria-errormessage]="id + 'lensObjectDetail'"
                                [attr.aria-invalid]="showError('lensObjectDetail')"
                            />
                        </label>
                        @if (showError('lensObjectDetail', 'required')) {
                            <span
                                [id]="id + 'lensObjectDetail'"
                                class="form-error-note"
                                aria-live="polite"
                                >Bitte gib die Seriennummer des Gerätes an.</span
                            >
                        } @else if (showError('lensObjectDetail', 'minlength')) {
                            <span
                                [id]="id + 'lensObjectDetail'"
                                class="form-error-note"
                                aria-live="polite"
                            >
                                Die Seriennummer sollte mindestens drei Zeichen lang sein.
                            </span>
                        }
                    </div>
                }
            </dl>
            @if (!allComplete()) {
                <div class="grid-container m-32:t">
                    <button
                        class="g-12 sm:g-6 sm:g-offset-6 -blue"
                        type="submit"
                        value="lens"
                        [disabled]="formGroup.controls.lensObjectDetail.invalid"
                    >
                        <i ctrlIcon="save"></i>Speichern
                    </button>
                </div>
            }
        }
    </form>
}
